export default "__VITE_ASSET__BM3bjy_1__"